import { render } from "./FormReturPenjualan.vue?vue&type=template&id=7946504a"
import script from "./FormReturPenjualan.vue?vue&type=script&lang=js"
export * from "./FormReturPenjualan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__